import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import DashboardPage from './pages/DashboardPage';
import CheckInDetailsPage from './pages/CheckInDetailsPage';

import Business4FlyoCheckInDetailsPage from './pages/Business4FlyoCheckInDetailsPage';
import ExtCheckInDetailsPage from './pages/ExtCheckInDetailsPage';
import UsersPage from './pages/UsersPage';
import UserInfoPage from './pages/UserInfoPage';
import AgentsPage from './pages/AgentsPage';
import ExtPartnerUsersPage from './pages/ExtPartnerUsersPage';
import AgentInfoPage from './pages/AgentInfoPage';
import BookingsPage from './pages/BookingsPage';
import BookingDetailsPage from './pages/BookingDetailsPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';

import { TripInfoProvider } from './context/TripInfoContext';
import { AuthProvider } from './context/AuthContext';
import { TicketProvider } from './context/TicketContext';
import { ApiCacheProvider } from './context/ApiCacheContext';
import './styles/global.css';

/**
 * Main App component
 * @returns {JSX.Element} App component
 */
function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ApiCacheProvider>
          <AuthProvider>
            <TripInfoProvider>
              <TicketProvider>
                <Router>
                  <Routes>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/" element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/check-in/:ticket_id/:user_id" element={
                    <ProtectedRoute>
                      <CheckInDetailsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/business4flyo/check-in/:ticketId" element={
                    <ProtectedRoute>
                      <Business4FlyoCheckInDetailsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/ext-check-in/:subscriptionId" element={
                    <ProtectedRoute>
                      <ExtCheckInDetailsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/users" element={
                    <ProtectedRoute>
                      <UsersPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/userInfo/:id" element={
                    <ProtectedRoute>
                      <UserInfoPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/external-partners" element={
                    <ProtectedRoute>
                      <ExtPartnerUsersPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/agents" element={
                    <ProtectedRoute>
                      <AgentsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/agents/:agentId" element={
                    <ProtectedRoute>
                      <AgentInfoPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/bookings" element={
                    <ProtectedRoute>
                      <BookingsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/bookings/:bookingId" element={
                    <ProtectedRoute>
                      <BookingDetailsPage />
                    </ProtectedRoute>
                  } />
                </Routes>
                </Router>
              </TicketProvider>
            </TripInfoProvider>
          </AuthProvider>
        </ApiCacheProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
